import React from "react";
import { FormGroup, Input } from "reactstrap";
import { Button, SelectPicker } from "rsuite";
import PropTypes from "prop-types";
import { Can, P, usePermission } from "../../rbac";
import searchIcon from "../../assets/img/search.svg";
import filterIcon from "../../assets/img/filter.svg";
import "./promotions.scss";

const PromotionsFilterBar = ({
  statusFilter,
  typeFilter,
  searchValue = "",
  onStatusFilterChange,
  onTypeFilterChange,
  onSearch,
  onSearchKeyDown,
  onExport,
  loading = false,
  isPilotHotel = false,
}) => {
  // EO-1264 — gated on the same permission as Export below. SelectPicker takes a data array, so
  // this cannot use <Can>, which gates JSX children; usePermission reads the identical source.
  const { allowed: canManage } = usePermission(P.Promotions.Manage);

  const statusOptions = [
    { label: "All Promos", value: "all" },
    { label: "Active Promos", value: "active" },
    { label: "Inactive Promos", value: "inactive" },
    { label: "Draft Promos", value: "draft" },
    ...(canManage ? [{ label: "Deleted Promos", value: "deleted" }] : []),
  ];

  const typeOptions = [
    { label: "All", value: "all" },
    {
      label: "Recommended promos only",
      value: "smart",
    },
    {
      label: "Custom promos only",
      value: "custom",
    },
    {
      label: "Campaign promos only",
      value: "buyer_campaign",
    },
  ];

  return (
    <div className="promotions-filter-bar">
      <div className="filter-label">
        <img src={filterIcon} alt="" className="filter-icon" />
        <span>Filter</span>
      </div>
      <FormGroup className="filter-dropdown">
        <SelectPicker
          id="status-filter-select"
          data-testid="status-filter-select"
          value={statusFilter}
          onChange={(value) => onStatusFilterChange(value)}
          disabled={loading}
          data={statusOptions}
          searchable={false}
          cleanable={false}
          block
        />
      </FormGroup>

      <FormGroup className="filter-dropdown">
        <SelectPicker
          id="type-filter-select"
          data-testid="type-filter-select"
          value={typeFilter}
          onChange={(value) => onTypeFilterChange(value)}
          disabled={loading}
          data={typeOptions}
          searchable={false}
          cleanable={false}
          block
        />
      </FormGroup>

      <div className="filter-search">
        <img src={searchIcon} alt="" className="search-icon" />
        <Input
          value={searchValue}
          onChange={onSearch}
          onKeyDown={onSearchKeyDown}
          placeholder="Search"
          disabled={loading}
        />
      </div>

      <Can permission={P.Promotions.Manage}>
        <Button
          appearance="ghost"
          onClick={onExport}
          disabled={loading}
          className="export-btn"
        >
          Export
        </Button>
      </Can>
    </div>
  );
};

PromotionsFilterBar.propTypes = {
  statusFilter: PropTypes.oneOf([
    "all",
    "active",
    "inactive",
    "draft",
    "deleted",
  ]).isRequired,
  typeFilter: PropTypes.oneOf(["all", "smart", "custom", "buyer_campaign"])
    .isRequired,
  searchValue: PropTypes.string,
  onStatusFilterChange: PropTypes.func.isRequired,
  onTypeFilterChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onSearchKeyDown: PropTypes.func,
  onExport: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  isPilotHotel: PropTypes.bool,
};

export default PromotionsFilterBar;
